import { DefaultThemeOptions } from './theme-options.js';
import { colors } from './colors.js';

var makeTheme = function makeTheme(_ref) {
  var _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? 'default' : _ref$themeName,
      _ref$themeOptions = _ref.themeOptions,
      themeOptions = _ref$themeOptions === void 0 ? DefaultThemeOptions : _ref$themeOptions;
  return {
    themeName: themeName,
    themeOptions: Object.assign(Object.assign({}, DefaultThemeOptions), themeOptions),
    baseFontSize: '100%',
    breakPoints: {
      small: '576px'
    },
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Open Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif',
    fontFamilyMonospace: 'SFMono-Medium, "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Courier, monospace',
    colors: Object.assign({}, colors),

    get alert() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;

      return {
        secondary: {
          backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray[50],
          textColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[900],
          borderColor: 'transparent',
          iconColor: (_e = (_d = this.colors) === null || _d === void 0 ? void 0 : _d.gray) === null || _e === void 0 ? void 0 : _e[600]
        },
        success: {
          backgroundColor: (_g = (_f = this.colors) === null || _f === void 0 ? void 0 : _f.green) === null || _g === void 0 ? void 0 : _g[50],
          textColor: (_j = (_h = this.colors) === null || _h === void 0 ? void 0 : _h.green) === null || _j === void 0 ? void 0 : _j[900],
          borderColor: 'transparent',
          iconColor: (_l = (_k = this.colors) === null || _k === void 0 ? void 0 : _k.green) === null || _l === void 0 ? void 0 : _l[600]
        },
        warning: {
          backgroundColor: (_o = (_m = this.colors) === null || _m === void 0 ? void 0 : _m.yellow) === null || _o === void 0 ? void 0 : _o[50],
          textColor: (_q = (_p = this.colors) === null || _p === void 0 ? void 0 : _p.yellow) === null || _q === void 0 ? void 0 : _q[900],
          borderColor: 'transparent',
          iconColor: (_s = (_r = this.colors) === null || _r === void 0 ? void 0 : _r.yellow) === null || _s === void 0 ? void 0 : _s[600]
        },
        danger: {
          backgroundColor: (_u = (_t = this.colors) === null || _t === void 0 ? void 0 : _t.red) === null || _u === void 0 ? void 0 : _u[50],
          textColor: (_w = (_v = this.colors) === null || _v === void 0 ? void 0 : _v.red) === null || _w === void 0 ? void 0 : _w[900],
          borderColor: 'transparent',
          iconColor: (_y = (_x = this.colors) === null || _x === void 0 ? void 0 : _x.red) === null || _y === void 0 ? void 0 : _y[600]
        },
        info: {
          backgroundColor: (_0 = (_z = this.colors) === null || _z === void 0 ? void 0 : _z.blue) === null || _0 === void 0 ? void 0 : _0[50],
          textColor: (_2 = (_1 = this.colors) === null || _1 === void 0 ? void 0 : _1.blue) === null || _2 === void 0 ? void 0 : _2[900],
          borderColor: 'transparent',
          iconColor: (_4 = (_3 = this.colors) === null || _3 === void 0 ? void 0 : _3.blue) === null || _4 === void 0 ? void 0 : _4[600]
        }
      };
    },

    get backgroundColor() {
      var _a, _b;

      return (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[50];
    },

    get baseTextColor() {
      var _a, _b;

      return (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[900];
    },

    get badge() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;

      return {
        "default": {
          backgroundColor: this.themeOptions.primaryColor,
          textColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[100]
        },
        inverted: {
          backgroundColor: (_d = (_c = this.colors) === null || _c === void 0 ? void 0 : _c.gray) === null || _d === void 0 ? void 0 : _d[200],
          textColor: (_f = (_e = this.colors) === null || _e === void 0 ? void 0 : _e.gray) === null || _f === void 0 ? void 0 : _f[800]
        },
        success: {
          backgroundColor: (_h = (_g = this.colors) === null || _g === void 0 ? void 0 : _g.green) === null || _h === void 0 ? void 0 : _h[100],
          textColor: (_k = (_j = this.colors) === null || _j === void 0 ? void 0 : _j.green) === null || _k === void 0 ? void 0 : _k[900]
        },
        warning: {
          backgroundColor: (_m = (_l = this.colors) === null || _l === void 0 ? void 0 : _l.orange) === null || _m === void 0 ? void 0 : _m[100],
          textColor: (_p = (_o = this.colors) === null || _o === void 0 ? void 0 : _o.yellow) === null || _p === void 0 ? void 0 : _p[900]
        },
        danger: {
          backgroundColor: (_r = (_q = this.colors) === null || _q === void 0 ? void 0 : _q.red) === null || _r === void 0 ? void 0 : _r[100],
          textColor: (_t = (_s = this.colors) === null || _s === void 0 ? void 0 : _s.red) === null || _t === void 0 ? void 0 : _t[900]
        },
        info: {
          backgroundColor: (_v = (_u = this.colors) === null || _u === void 0 ? void 0 : _u['light-blue']) === null || _v === void 0 ? void 0 : _v[100],
          textColor: (_x = (_w = this.colors) === null || _w === void 0 ? void 0 : _w['light-blue']) === null || _x === void 0 ? void 0 : _x[900]
        }
      };
    },

    get comboBox() {
      var _a, _b;

      return {
        backgroundColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[200]
      };
    },

    get dashboardWidget() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.36)',
        label: {
          textColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[600]
        },
        "default": {
          value: {
            textColor: (_d = this.colors) === null || _d === void 0 ? void 0 : _d.black
          }
        },
        primary: {
          value: {
            textColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_e = this.colors) === null || _e === void 0 ? void 0 : _e.primary
          }
        },
        danger: {
          value: {
            textColor: (_g = (_f = this.colors) === null || _f === void 0 ? void 0 : _f.red) === null || _g === void 0 ? void 0 : _g[600]
          }
        },
        warning: {
          value: {
            textColor: (_j = (_h = this.colors) === null || _h === void 0 ? void 0 : _h.yellow) === null || _j === void 0 ? void 0 : _j[600]
          }
        },
        success: {
          value: {
            textColor: (_l = (_k = this.colors) === null || _k === void 0 ? void 0 : _k.green) === null || _l === void 0 ? void 0 : _l[600]
          }
        }
      };
    },

    get input() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;

      return {
        borderColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[300],
        focusColor: (_d = (_c = this.colors) === null || _c === void 0 ? void 0 : _c.blue) === null || _d === void 0 ? void 0 : _d[500],
        invalidBorderColor: (_f = (_e = this.colors) === null || _e === void 0 ? void 0 : _e.red) === null || _f === void 0 ? void 0 : _f[500],
        validBorderColor: (_h = (_g = this.colors) === null || _g === void 0 ? void 0 : _g.green) === null || _h === void 0 ? void 0 : _h[500],
        prefilledTextColor: (_k = (_j = this.colors) === null || _j === void 0 ? void 0 : _j.purple) === null || _k === void 0 ? void 0 : _k[600]
      };
    },

    get inputGroup() {
      var _a, _b, _c, _d, _e;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        borderColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[300],
        focusBorderColor: (_e = (_d = this.colors) === null || _d === void 0 ? void 0 : _d.blue) === null || _e === void 0 ? void 0 : _e[500]
      };
    },

    get button() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;

      return {
        tertiary: {
          backgroundColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[200],
          hoverBackgroundColor: (_d = (_c = this.colors) === null || _c === void 0 ? void 0 : _c.gray) === null || _d === void 0 ? void 0 : _d[100],
          textColor: (_f = (_e = this.colors) === null || _e === void 0 ? void 0 : _e.gray) === null || _f === void 0 ? void 0 : _f[900],
          hoverTextColor: (_h = (_g = this.colors) === null || _g === void 0 ? void 0 : _g.gray) === null || _h === void 0 ? void 0 : _h[700],
          activeBackgroundColor: (_k = (_j = this.colors) === null || _j === void 0 ? void 0 : _j.gray) === null || _k === void 0 ? void 0 : _k[300],
          outlineBorderColor: (_m = (_l = this.colors) === null || _l === void 0 ? void 0 : _l.gray) === null || _m === void 0 ? void 0 : _m[300],
          outlineTextColor: (_p = (_o = this.colors) === null || _o === void 0 ? void 0 : _o.gray) === null || _p === void 0 ? void 0 : _p[900],
          outlineHoverTextColor: (_r = (_q = this.colors) === null || _q === void 0 ? void 0 : _q.gray) === null || _r === void 0 ? void 0 : _r[700],
          outlineHoverBorderColor: (_t = (_s = this.colors) === null || _s === void 0 ? void 0 : _s.gray) === null || _t === void 0 ? void 0 : _t[400],
          outlineActiveBorderColor: (_v = (_u = this.colors) === null || _u === void 0 ? void 0 : _u.gray) === null || _v === void 0 ? void 0 : _v[500]
        },
        primary: {
          backgroundColor: (_w = this.themeOptions) === null || _w === void 0 ? void 0 : _w.primaryButtonBackgroundColor,
          hoverBackgroundColor: (_x = this.themeOptions) === null || _x === void 0 ? void 0 : _x.primaryButtonHoverBackgroundColor,
          textColor: (_y = this.themeOptions) === null || _y === void 0 ? void 0 : _y.primaryButtonTextColor,
          hoverTextColor: (_z = this.themeOptions) === null || _z === void 0 ? void 0 : _z.primaryButtonHoverTextColor,
          activeBackgroundColor: (_0 = this.themeOptions) === null || _0 === void 0 ? void 0 : _0.primaryButtonActiveBackgroundColor,
          outlineBorderColor: (_1 = this.themeOptions) === null || _1 === void 0 ? void 0 : _1.primaryButtonOutlineBorderColor,
          outlineTextColor: (_2 = this.themeOptions) === null || _2 === void 0 ? void 0 : _2.primaryButtonOutlineTextColor,
          outlineHoverTextColor: (_3 = this.themeOptions) === null || _3 === void 0 ? void 0 : _3.primaryButtonOutlineHoverTextColor,
          outlineHoverBorderColor: (_4 = this.themeOptions) === null || _4 === void 0 ? void 0 : _4.primaryButtonOutlineHoverBorderColor,
          outlineActiveBorderColor: (_5 = this.themeOptions) === null || _5 === void 0 ? void 0 : _5.primaryButtonOutlineActiveBorderColor
        },
        secondary: {
          backgroundColor: 'transparent',
          hoverBackgroundColor: 'transparent',
          borderColor: (_7 = (_6 = this.colors) === null || _6 === void 0 ? void 0 : _6.gray) === null || _7 === void 0 ? void 0 : _7[900],
          borderHoverColor: (_9 = (_8 = this.colors) === null || _8 === void 0 ? void 0 : _8.gray) === null || _9 === void 0 ? void 0 : _9[600],
          textColor: (_11 = (_10 = this.colors) === null || _10 === void 0 ? void 0 : _10.gray) === null || _11 === void 0 ? void 0 : _11[900],
          hoverTextColor: (_13 = (_12 = this.colors) === null || _12 === void 0 ? void 0 : _12.gray) === null || _13 === void 0 ? void 0 : _13[700],
          activeBackgroundColor: (_15 = (_14 = this.colors) === null || _14 === void 0 ? void 0 : _14.gray) === null || _15 === void 0 ? void 0 : _15[100]
        },
        ghost: {
          backgroundColor: 'transparent',
          textColor: (_17 = (_16 = this.colors) === null || _16 === void 0 ? void 0 : _16.gray) === null || _17 === void 0 ? void 0 : _17[900],
          activeBackgroundColor: (_19 = (_18 = this.colors) === null || _18 === void 0 ? void 0 : _18.gray) === null || _19 === void 0 ? void 0 : _19[300]
        }
      };
    },

    get card() {
      return {
        backgroundColor: '#fff',
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.2)'
      };
    },

    get dropdownMenu() {
      var _a, _b, _c, _d;

      return {
        backgroundColor: '#fff',
        borderColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[300],
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)',
        sectionHeaderColor: (_d = (_c = this.colors) === null || _c === void 0 ? void 0 : _c.gray) === null || _d === void 0 ? void 0 : _d[600]
      };
    },

    get dropdownMenuItem() {
      var _a, _b, _c, _d, _e, _f;

      return {
        highlightColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[100],
        selectedColor: (_d = (_c = this.colors) === null || _c === void 0 ? void 0 : _c.gray) === null || _d === void 0 ? void 0 : _d[200],
        descriptionFontColor: (_f = (_e = this.colors) === null || _e === void 0 ? void 0 : _e.gray) === null || _f === void 0 ? void 0 : _f[600]
      };
    },

    get checkbox() {
      var _a, _b, _c, _d, _e, _f, _g;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        borderColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[300],
        checkedBackgroundColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_d = this.colors) === null || _d === void 0 ? void 0 : _d.primary,
        checkColor: (_e = this.colors) === null || _e === void 0 ? void 0 : _e.white,
        focusColor: (_g = (_f = this.colors) === null || _f === void 0 ? void 0 : _f.gray) === null || _g === void 0 ? void 0 : _g[300]
      };
    },

    get radio() {
      var _a, _b, _c, _d, _e, _f, _g, _h;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        borderColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[300],
        checkedBackgroundColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_d = this.colors) === null || _d === void 0 ? void 0 : _d.primary,
        checkedBorderColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_e = this.colors) === null || _e === void 0 ? void 0 : _e.primary,
        checkColor: (_f = this.colors) === null || _f === void 0 ? void 0 : _f.white,
        focusColor: (_h = (_g = this.colors) === null || _g === void 0 ? void 0 : _g.gray) === null || _h === void 0 ? void 0 : _h[300]
      };
    },

    get switch() {
      var _a, _b, _c, _d, _e, _f;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray[400],
        boxShadow: 'inset 0px 0px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 2px rgba(0, 0, 0, 0.1);',
        checkedBackgroundColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[900],
        toggleBackgroundColor: (_d = this.colors) === null || _d === void 0 ? void 0 : _d.white,
        focusColor: (_f = (_e = this.colors) === null || _e === void 0 ? void 0 : _e.gray) === null || _f === void 0 ? void 0 : _f[300]
      };
    },

    get clientSwitcher() {
      var _a, _b;

      return {
        rowBoxShadowColor: 'rgba(0, 0, 0, 0.05)',
        clientIdTextColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[600]
      };
    },

    get slideoutPanel() {
      var _a, _b;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)',
        footerBorderColor: (_b = this.colors.gray) === null || _b === void 0 ? void 0 : _b[300]
      };
    },

    get modal() {
      var _a;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.2), 0px 12px 24px rgba(0, 0, 0, 0.1)'
      };
    },

    get breadcrumb() {
      var _a, _b, _c, _d, _e, _f;

      return {
        textColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[600],
        activeTextColor: (_d = (_c = this.colors) === null || _c === void 0 ? void 0 : _c.blue) === null || _d === void 0 ? void 0 : _d[600],
        hoverTextColor: (_f = (_e = this.colors) === null || _e === void 0 ? void 0 : _e.blue) === null || _f === void 0 ? void 0 : _f[700]
      };
    },

    get toast() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35;

      return {
        boxShadow: ' 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1);',
        secondary_bold: {
          backgroundColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[700],
          textColor: (_c = this.colors) === null || _c === void 0 ? void 0 : _c.white,
          iconColor: (_d = this.colors) === null || _d === void 0 ? void 0 : _d.white
        },
        success_bold: {
          backgroundColor: (_f = (_e = this.colors) === null || _e === void 0 ? void 0 : _e.green) === null || _f === void 0 ? void 0 : _f[700],
          textColor: (_g = this.colors) === null || _g === void 0 ? void 0 : _g.white,
          iconColor: (_h = this.colors) === null || _h === void 0 ? void 0 : _h.white
        },
        warning_bold: {
          backgroundColor: (_k = (_j = this.colors) === null || _j === void 0 ? void 0 : _j.yellow) === null || _k === void 0 ? void 0 : _k[700],
          textColor: (_l = this.colors) === null || _l === void 0 ? void 0 : _l.white,
          iconColor: (_m = this.colors) === null || _m === void 0 ? void 0 : _m.white
        },
        danger_bold: {
          backgroundColor: (_p = (_o = this.colors) === null || _o === void 0 ? void 0 : _o.red) === null || _p === void 0 ? void 0 : _p[700],
          textColor: (_q = this.colors) === null || _q === void 0 ? void 0 : _q.white,
          iconColor: (_r = this.colors) === null || _r === void 0 ? void 0 : _r.white
        },
        info_bold: {
          backgroundColor: (_t = (_s = this.colors) === null || _s === void 0 ? void 0 : _s.blue) === null || _t === void 0 ? void 0 : _t[700],
          textColor: (_u = this.colors) === null || _u === void 0 ? void 0 : _u.white,
          iconColor: (_v = this.colors) === null || _v === void 0 ? void 0 : _v.white
        },
        secondary: {
          backgroundColor: (_x = (_w = this.colors) === null || _w === void 0 ? void 0 : _w.gray) === null || _x === void 0 ? void 0 : _x[50],
          textColor: (_z = (_y = this.colors) === null || _y === void 0 ? void 0 : _y.gray) === null || _z === void 0 ? void 0 : _z[900],
          iconColor: (_1 = (_0 = this.colors) === null || _0 === void 0 ? void 0 : _0.gray) === null || _1 === void 0 ? void 0 : _1[600]
        },
        success: {
          backgroundColor: (_3 = (_2 = this.colors) === null || _2 === void 0 ? void 0 : _2.green) === null || _3 === void 0 ? void 0 : _3[50],
          textColor: (_5 = (_4 = this.colors) === null || _4 === void 0 ? void 0 : _4.green) === null || _5 === void 0 ? void 0 : _5[900],
          iconColor: (_7 = (_6 = this.colors) === null || _6 === void 0 ? void 0 : _6.green) === null || _7 === void 0 ? void 0 : _7[600]
        },
        info: {
          backgroundColor: (_9 = (_8 = this.colors) === null || _8 === void 0 ? void 0 : _8.blue) === null || _9 === void 0 ? void 0 : _9[50],
          textColor: (_11 = (_10 = this.colors) === null || _10 === void 0 ? void 0 : _10.blue) === null || _11 === void 0 ? void 0 : _11[900],
          iconColor: (_13 = (_12 = this.colors) === null || _12 === void 0 ? void 0 : _12.blue) === null || _13 === void 0 ? void 0 : _13[600]
        },
        warning: {
          backgroundColor: (_15 = (_14 = this.colors) === null || _14 === void 0 ? void 0 : _14.yellow) === null || _15 === void 0 ? void 0 : _15[50],
          textColor: (_17 = (_16 = this.colors) === null || _16 === void 0 ? void 0 : _16.yellow) === null || _17 === void 0 ? void 0 : _17[900],
          iconColor: (_19 = (_18 = this.colors) === null || _18 === void 0 ? void 0 : _18.yellow) === null || _19 === void 0 ? void 0 : _19[600]
        },
        danger: {
          backgroundColor: (_21 = (_20 = this.colors) === null || _20 === void 0 ? void 0 : _20.red) === null || _21 === void 0 ? void 0 : _21[50],
          textColor: (_23 = (_22 = this.colors) === null || _22 === void 0 ? void 0 : _22.red) === null || _23 === void 0 ? void 0 : _23[900],
          iconColor: (_25 = (_24 = this.colors) === null || _24 === void 0 ? void 0 : _24.red) === null || _25 === void 0 ? void 0 : _25[600]
        },
        neutral: {
          backgroundColor: (_27 = (_26 = this.colors) === null || _26 === void 0 ? void 0 : _26.gray) === null || _27 === void 0 ? void 0 : _27[50],
          textColor: (_29 = (_28 = this.colors) === null || _28 === void 0 ? void 0 : _28.gray) === null || _29 === void 0 ? void 0 : _29[900],
          iconColor: (_31 = (_30 = this.colors) === null || _30 === void 0 ? void 0 : _30.gray) === null || _31 === void 0 ? void 0 : _31[600]
        },
        neutral_bold: {
          backgroundColor: (_33 = (_32 = this.colors) === null || _32 === void 0 ? void 0 : _32.gray) === null || _33 === void 0 ? void 0 : _33[700],
          textColor: (_34 = this.colors) === null || _34 === void 0 ? void 0 : _34.white,
          iconColor: (_35 = this.colors) === null || _35 === void 0 ? void 0 : _35.white
        }
      };
    },

    get datePicker() {
      var _a, _b, _c, _d, _e, _f, _g;

      return {
        dropdownMenuBackgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        dropdownMenuTextColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[900],
        dropdownMenuBoxShadow: '0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)',
        dateHoverColor: (_e = (_d = this.colors) === null || _d === void 0 ? void 0 : _d.gray) === null || _e === void 0 ? void 0 : _e[100],
        dateSelectedColor: (_g = (_f = this.colors) === null || _f === void 0 ? void 0 : _f.blue) === null || _g === void 0 ? void 0 : _g[600]
      };
    },

    get pagination() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        borderColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[200],
        textColor: (_e = (_d = this.colors) === null || _d === void 0 ? void 0 : _d.gray) === null || _e === void 0 ? void 0 : _e[600],
        hoverBackgroundColor: (_g = (_f = this.colors) === null || _f === void 0 ? void 0 : _f.gray) === null || _g === void 0 ? void 0 : _g[100],
        hoverTextColor: (_j = (_h = this.colors) === null || _h === void 0 ? void 0 : _h.gray) === null || _j === void 0 ? void 0 : _j[600],
        activeBackgroundColor: (_l = (_k = this.colors) === null || _k === void 0 ? void 0 : _k.blue) === null || _l === void 0 ? void 0 : _l[50],
        activeTextColor: (_o = (_m = this.colors) === null || _m === void 0 ? void 0 : _m.blue) === null || _o === void 0 ? void 0 : _o[600],
        activeBorderColor: (_q = (_p = this.colors) === null || _p === void 0 ? void 0 : _p.blue) === null || _q === void 0 ? void 0 : _q[600],
        disabledBackgroundColor: (_s = (_r = this.colors) === null || _r === void 0 ? void 0 : _r.gray) === null || _s === void 0 ? void 0 : _s[200],
        disabledTextColor: (_u = (_t = this.colors) === null || _t === void 0 ? void 0 : _t.gray) === null || _u === void 0 ? void 0 : _u[300]
      };
    },

    get popover() {
      var _a;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)'
      };
    },

    get progressBar() {
      var _a, _b, _c;

      return {
        backgroundColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[200],
        barBackgroundColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_c = this.colors) === null || _c === void 0 ? void 0 : _c.primary
      };
    },

    get select() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;

      return {
        borderColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[400],
        backgroundColor: (_c = this.colors) === null || _c === void 0 ? void 0 : _c.white,
        multiValueBackgroundColor: (_e = (_d = this.colors) === null || _d === void 0 ? void 0 : _d.gray) === null || _e === void 0 ? void 0 : _e[200],
        multiValueRemoveHoverColor: (_g = (_f = this.colors) === null || _f === void 0 ? void 0 : _f.gray) === null || _g === void 0 ? void 0 : _g[900],
        focusedBoxShadowColor: (_j = (_h = this.colors) === null || _h === void 0 ? void 0 : _h.blue) === null || _j === void 0 ? void 0 : _j[600],
        menuFilterColor: 'drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.2)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1))',
        optionHoverBackgroundColor: (_l = (_k = this.colors) === null || _k === void 0 ? void 0 : _k.gray) === null || _l === void 0 ? void 0 : _l[100],
        groupHeadingColor: (_o = (_m = this.colors) === null || _m === void 0 ? void 0 : _m.gray) === null || _o === void 0 ? void 0 : _o[900]
      };
    },

    get tooltip() {
      var _a;

      return {
        backgroundColor: 'rgba(17, 24, 39, 0.8)',
        textColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white
      };
    },

    get listGroup() {
      var _a, _b, _c, _d, _e;

      return {
        itemBackgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        itemHoverBackgroundColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[100],
        itemActiveBackgroundColor: (_e = (_d = this.colors) === null || _d === void 0 ? void 0 : _d.gray) === null || _e === void 0 ? void 0 : _e[200]
      };
    },

    get tabs() {
      var _a, _b, _c, _d, _e, _f;

      return {
        textColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[600],
        activeTextColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_c = this.colors) === null || _c === void 0 ? void 0 : _c.primary,
        hoverTextColor: (_e = (_d = this.colors) === null || _d === void 0 ? void 0 : _d.gray) === null || _e === void 0 ? void 0 : _e[800],
        activeBorderColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_f = this.colors) === null || _f === void 0 ? void 0 : _f.primary
      };
    },

    get searchToken() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;

      return {
        padding: '4px 6px',
        borderRadius: '6px',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '600',
        iconIconColor: (_b = (_a = this.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[600],
        dismissIconColor: (_d = (_c = this.colors) === null || _c === void 0 ? void 0 : _c.gray) === null || _d === void 0 ? void 0 : _d[500],
        gray: {
          backgroundColor: (_f = (_e = this.colors) === null || _e === void 0 ? void 0 : _e.gray) === null || _f === void 0 ? void 0 : _f[100],
          textColor: (_h = (_g = this.colors) === null || _g === void 0 ? void 0 : _g.gray) === null || _h === void 0 ? void 0 : _h[900],
          boxShadow: 'none',
          hoverBackgroundColor: (_k = (_j = this.colors) === null || _j === void 0 ? void 0 : _j.blue) === null || _k === void 0 ? void 0 : _k[50],
          hoverTextColor: (_m = (_l = this.colors) === null || _l === void 0 ? void 0 : _l.blue) === null || _m === void 0 ? void 0 : _m[700],
          disabledBackgroundColor: (_p = (_o = this.colors) === null || _o === void 0 ? void 0 : _o.gray) === null || _p === void 0 ? void 0 : _p[100],
          disabledTextColor: (_r = (_q = this.colors) === null || _q === void 0 ? void 0 : _q.gray) === null || _r === void 0 ? void 0 : _r[400]
        },
        white: {
          backgroundColor: (_s = this.colors) === null || _s === void 0 ? void 0 : _s.white,
          textColor: (_u = (_t = this.colors) === null || _t === void 0 ? void 0 : _t.gray) === null || _u === void 0 ? void 0 : _u[900],
          boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.10), 0px 0px 1px 0px rgba(0, 0, 0, 0.20)',
          hoverBackgroundColor: (_w = (_v = this.colors) === null || _v === void 0 ? void 0 : _v.blue) === null || _w === void 0 ? void 0 : _w[50],
          hoverTextColor: (_y = (_x = this.colors) === null || _x === void 0 ? void 0 : _x.blue) === null || _y === void 0 ? void 0 : _y[700],
          disabledBackgroundColor: (_z = this.colors) === null || _z === void 0 ? void 0 : _z.white,
          disabledTextColor: (_1 = (_0 = this.colors) === null || _0 === void 0 ? void 0 : _0.gray) === null || _1 === void 0 ? void 0 : _1[400]
        }
      };
    },

    get sidebarNav() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        borderColor: (_c = (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray) === null || _c === void 0 ? void 0 : _c[300],
        boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.36)',
        textColor: (_e = (_d = this.colors) === null || _d === void 0 ? void 0 : _d.gray) === null || _e === void 0 ? void 0 : _e[900],
        navItem: {
          selectedBackgroundColor: (_g = (_f = this.colors) === null || _f === void 0 ? void 0 : _f.blue) === null || _g === void 0 ? void 0 : _g[50],
          selectedTextColor: (_j = (_h = this.colors) === null || _h === void 0 ? void 0 : _h.blue) === null || _j === void 0 ? void 0 : _j[800],
          hoverTextColor: (_l = (_k = this.colors) === null || _k === void 0 ? void 0 : _k.blue) === null || _l === void 0 ? void 0 : _l[700]
        },
        header: {
          borderColor: (_o = (_m = this.colors) === null || _m === void 0 ? void 0 : _m.gray) === null || _o === void 0 ? void 0 : _o[100],
          separatorColor: (_q = (_p = this.colors) === null || _p === void 0 ? void 0 : _p.gray) === null || _q === void 0 ? void 0 : _q[200],
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          breadcrumb: {
            textColor: (_s = (_r = this.colors) === null || _r === void 0 ? void 0 : _r.gray) === null || _s === void 0 ? void 0 : _s[500],
            activeTextColor: (_u = (_t = this.colors) === null || _t === void 0 ? void 0 : _t.gray) === null || _u === void 0 ? void 0 : _u[900],
            hoverTextColor: (_w = (_v = this.colors) === null || _v === void 0 ? void 0 : _v.blue) === null || _w === void 0 ? void 0 : _w[500]
          }
        },
        badge: {
          textColor: (_y = (_x = this.colors) === null || _x === void 0 ? void 0 : _x.blue) === null || _y === void 0 ? void 0 : _y[700],
          borderColor: (_0 = (_z = this.colors) === null || _z === void 0 ? void 0 : _z.gray) === null || _0 === void 0 ? void 0 : _0[200]
        }
      };
    },

    get actionSheet() {
      var _a, _b, _c;

      return {
        backgroundColor: (_a = this.colors) === null || _a === void 0 ? void 0 : _a.white,
        borderRadius: '6px',
        boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)',
        footerBorderColor: (_b = this.colors) === null || _b === void 0 ? void 0 : _b.gray[200],
        footerButtonTextColor: (_c = this.colors) === null || _c === void 0 ? void 0 : _c.gray[600]
      };
    }

  };
};

export { makeTheme as default };